(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grab-and-go-fields"] && !Shopify.designMode) return;
  try {
    const addBusinessDays = (startDate, days) => {
    const date = new Date(startDate);
    let remaining = days;

    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 1) remaining -= 1;
    }

    return date;
  };

  const toDateInputValue = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  document.querySelectorAll('[data-grab-go-pickup-date]').forEach((input) => {
    input.min = toDateInputValue(addBusinessDays(new Date(), 3));

    const validatePickupDay = () => {
      input.setCustomValidity('');
      if (!input.value) return;

      const requested = new Date(`${input.value}T12:00:00`);
      if (requested.getDay() === 1) {
        input.setCustomValidity('Monday pickup is unavailable. Please select Tuesday through Sunday.');
      }
    };

    input.addEventListener('input', validatePickupDay);
    input.addEventListener('change', validatePickupDay);
  });
  } catch(e) { console.error(e); }
})();

})();
